export const absurd = (x: never): never => {
  throw new Error(
    `Absurd value received; this should never happen: ${JSON.stringify(
      x,
    )} -> ${typeof x}`,
  );
};
